import Skeleton from './skeleton';
export default Skeleton;
export * from './interface';